import type { Caption, CaptionStyle } from '@/types/scene';

interface StyleDef {
  font: string;
  size: number;
  weight: string;
  fillColor: string;
  strokeColor: string;
  strokeWidth: number;
  y: number;
}

export const CAPTION_STYLES: Record<CaptionStyle, StyleDef> = {
  yellow_impact: {
    font: 'Anton, sans-serif',
    size: 96,
    weight: 'bold',
    fillColor: '#FFD93D',
    strokeColor: '#000000',
    strokeWidth: 12,
    y: 280,
  },
  white_clean: {
    font: 'Noto Sans JP, sans-serif',
    size: 72,
    weight: '900',
    fillColor: '#FFFFFF',
    strokeColor: '#000000',
    strokeWidth: 8,
    y: 320,
  },
  red_alert: {
    font: 'Anton, sans-serif',
    size: 88,
    weight: 'bold',
    fillColor: '#FF2D4E',
    strokeColor: '#FFFFFF',
    strokeWidth: 10,
    y: 300,
  },
  black_minimal: {
    font: 'Noto Sans JP, sans-serif',
    size: 64,
    weight: '500',
    fillColor: '#000000',
    strokeColor: '#FFFFFF',
    strokeWidth: 4,
    y: 340,
  },
};

export function drawCaption(
  ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
  caption: Caption | null,
  canvasWidth: number,
) {
  if (!caption) return;
  const style = CAPTION_STYLES[caption.style];
  ctx.save();
  ctx.font = `${style.weight} ${style.size}px ${style.font}`;
  ctx.textAlign = 'center';
  ctx.lineJoin = 'round';
  ctx.miterLimit = 2;
  ctx.lineWidth = style.strokeWidth;
  ctx.strokeStyle = style.strokeColor;
  ctx.strokeText(caption.text, canvasWidth / 2, style.y);
  ctx.fillStyle = style.fillColor;
  ctx.fillText(caption.text, canvasWidth / 2, style.y);
  ctx.restore();
}
